export const STORAGE_KEY_CHARACTERS = "embersrpgvault-characters";

export const initialState = {
  all: [],
  current: {},
  dirty: false,
  inSync: true
};

if (localStorage.getItem(STORAGE_KEY_CHARACTERS)) {
  let storage = JSON.parse(localStorage.getItem(STORAGE_KEY_CHARACTERS));

  if (storage) {
    if (storage.all) {
      initialState.all = storage.all;
    }
    if (storage.current) {
      initialState.current = storage.current;
    }
  }
}

export const state = initialState;
